/**
 * Fecha ISO YYYY-MM-DD → texto legible (ej. 15 may 2026) para evitar confusión día/mes.
 * Usa mediodía local al parsear para no desplazar el día por UTC.
 */
export function formatLicenseDateForDisplay(iso) {
  const s = String(iso || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return (iso || "").trim() || "—";
  const [y, m, d] = s.split("-").map((n) => parseInt(n, 10));
  const dt = new Date(y, m - 1, d, 12, 0, 0, 0);
  if (Number.isNaN(dt.getTime())) return s;
  const t = dt.toLocaleDateString("es-MX", { day: "numeric", month: "short", year: "numeric" });
  return t.replace(/\./g, "").trim();
}
